import * as React from 'react'
import { RouteProps, Route } from 'react-router-dom'
import { connect } from 'react-redux'
import { permissionMatrix } from './permissionMatrix'
import { PageType } from '../enums'
import { Message } from 'semantic-ui-react'

interface IAuthRouteProps extends RouteProps {
  pageType: PageType,
  loggedIn: boolean,
  userInfo: IUserInfo,
}

class AuthRoute extends React.Component<IAuthRouteProps> {

  checkPermission = (userInfo: IUserInfo, pageType: PageType) => {
    let permission = permissionMatrix.isValidUser(userInfo, pageType)
    if (permission) {
      return permission
    }
    return permission
  }

  render() {
    const { pageType, userInfo, component: Component, ...rest } = this.props

    return (
      <Route
        {...rest}
        render={(props: any) => (
          this.checkPermission(userInfo, pageType)
            ? Component && <Component {...props} />
            : <Message error={true}>Bạn không có quyền truy cập vào trang này!</Message>
        )}
      />
    )
  }
}

const mapStateToProps = (state: IAppState, ownProps: any) => ({
  ...ownProps,
  loggedIn: state.loggedIn,
  userInfo: state.root.userInfo
})

export default connect(mapStateToProps)(AuthRoute)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/core/AuthRoute.tsx